import { Formik } from "formik";
import { Form, Col, Row } from "react-bootstrap";
import { BookCategoryOptions, CustomSelect, getBookTypeOptions, GradeOptions } from "../../../../../../_helpers/Helpers";

export function BookEditForm({ 
  book,
  bookTypeOptions,
  setBookTypeOptions,
  btnRef,
  saveBook
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={book}
      onSubmit={(values) => saveBook(values)}
    >
      {({ handleSubmit, handleChange, setFieldValue, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="name">
            <Form.Label column sm={2}>
              Adı<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.name} placeholder="Adı" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="author">
            <Form.Label column sm={2}>
              Yazarı<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.author} placeholder="Yazarı" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="publisher">
            <Form.Label column sm={2}>
              Yayınevi
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.publisher} placeholder="Yayınevi" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="category">
            <Form.Label column sm={2}>
              Kategorisi<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <CustomSelect
                options={BookCategoryOptions}
                value={values.category}
                onChange={option => {
                  setFieldValue("category", option.value);
                  setBookTypeOptions(getBookTypeOptions(option.value));
                }}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="type">
            <Form.Label column sm={2}>
              Türü<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <CustomSelect
                options={bookTypeOptions}
                value={values.type}
                onChange={option => setFieldValue("type", option.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="grade">
            <Form.Label column sm={2}>
              Sınıf<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <CustomSelect
                options={GradeOptions}
                value={values.grade}
                onChange={option => setFieldValue("grade", option.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="pageNumber">
            <Form.Label column sm={2}>
              Sayfa Sayısı<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="number" min="1" value={values.pageNumber} placeholder="Sayfa Sayısı" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="explanation">
            <Form.Label column sm={2}>
              Açıklaması
            </Form.Label>
            <Col sm={10}>
              <Form.Control as="textarea" rows="3" value={values.explanation} placeholder="Açıklaması" onChange={handleChange} />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}